export const DEFAULT_COUNTRY_CODE: string = 'THA';
export const DEFUALT_NATIONALITY_CODE: string = 'TH';
